<template>
<el-dialog width="80%" :visible.sync="visible" :before-close="this.befclose" class="priceDialog" @opened="openedDialog" :close-on-click-modal="false">
	<div class="page-content bm bm-ver bm-f1">
		<div class="options bm bm-ver">
			<div class="bm bm-f1 bm-pj titleInfo">
				<div class="title bm bm-ac">
					下为<span>「{{selectedCityData.provinceName}}」</span>的所选产品的价格制定默认预算值，如有预算意见请修改
				</div>
				<div class="bm">
					<el-button size="mini" :disabled="!showTable" @click="befclose">取 消</el-button>
					<el-button size="mini" :disabled="!showTable" type="primary" @click="confirm">确 定</el-button>
				</div>
			</div>
			<div class="bm bm-pj bm-f1">
				<div class="bm bm-ac productNameBox">
					<div class="bm bm-ac bm-pe tabDes cellLineProName">产品类型</div>
					<el-select v-model="changedType" size="mini" clearable @change="checkPrice" placeholder="全部产品">
						<el-option
						v-for="item in productTypes"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div>
					<!-- <el-button size="mini" class="export" type="default" @click="downLoad"><span>下载模板</span></el-button> -->
					<el-button size="mini" class="export" type="default" @click="checkOut"><span>导出</span></el-button>
				</div>
			</div>
		</div>
		<div class="bm bm-f1 tableBox" ref="priceOpinionHeight" v-loading="!showTable" >
			<u-table
				v-if="showTable"
				:height="this.$refs.priceOpinionHeight?this.$refs.priceOpinionHeight.offsetHeight:'100px'"
				:use-virtual="false"
				:key="tableKey"
				:data="priceTableData"
				:cell-class-name="tableCellClassName"
				align="center"
				style="width: 100%"
				size="small"
				:row-height="47"
				:header-cell-style="{color: '#323232','font-size': '14px','background-color': '#ffffff',height: '47px','border-right': '1px solid #ebeef5'}">
				<multi-type-pl-column
					v-for="(item, index) in tableHead"
					:key="index"
					:col="item"
					:required="true"
					:editField="editField"
					:editFieldType="editFieldType"
					:editFildHide="editFieldHideBpc"
					:formatterList="formatterList"
					:tableData="priceTableData"
					:pasteField="pasteField"
					@pasteData="pasteData"
					@modification="modification" 
					@loseFocus="loseFocus">
				</multi-type-pl-column>
			</u-table>
		</div>
	</div>
</el-dialog>
</template>
<script>
import {salesApi}  from "@/services";
import { UTable, UTableColumn } from 'umy-ui'
export default {
	components: {
		UTable,
		UTableColumn
	},
	props:{
		visible: {
			type: Boolean,
			required: true,
			default:false
		},
		priceTableData: {
			type: Array,
			required: true,
			default() {
				return []
			}
		},
		selectedCityData:{
			type: Object
		},
		priceOpinionType:{
			type:String
		},
		type: {
			type: String,
			default() {
				return ""
			}
		},
	},
	watch:{
		priceOpinionType:{
			immediate: true, 
			handler(newStr){
				// this.tableHead[6].label=`中标价-${newStr}`;
				// this.tableHead[8].label=`去税/扣减折扣-预算-${newStr}`;
			}
		}
	},
	data(){
		return{
			showTable: false,
			tableHead: [
				{
                    prop: "materialName",
                    label: "产品名称",
					width:"200px",
					fixed:"left"
				},
				{
                    prop: "materialCode",
                    label: "产品编码",
					width:"150px",
				},
				{
                    prop: "baseMeasureUnit",
					label: "单位",
					width:"100px",
                },
                {
                    prop: "provinceName",
                    label: "省份",
                    width:"200px",
                },
               	{
					prop: "sfSales",
					label: "是否上市",
					width:"100px",
				},
                {
                    prop: "1",
					label: "执行中-中标价/开票价",
					isShowTip: true,
                    children: [
                        {
                            prop: "executingBidPrice",
                            label: "执行中中标价（元）",
                            width:"160px"
                            
                        },
                        {
                            prop: "executingInvoicePrice",
                            label: "执行中开票价（元）",
                            width:"160px"
                            
                        },
                        {
                            prop: "executingPriceDownRatio",
                            label: "执行中下浮比例(%)",
                            width:"145px"
                            
                        }
					]
                },
                {
                    prop: "2",
					label: "预计中标价",
					isShowTip: true,
                    children: [
                        {
                            prop: "adviseBidPrice ",
                            label: "预计中标价(元)",
							width:"140px",
							maxLength:9
						},
						{
							prop: "adviseStartExecDate",
							label: "预计执行时间",
							width: "160px"
                        }
                    ]
				},
                {
                    prop: "3",
					label: "预计开票价",
					isShowTip: true,
                    children: [
						 {
                            prop: "invoicePriceDownRatio",
                            label: "预计下浮比例(%)",
							width: "160px",
							maxLength:4
                            
                        },
                        {
                            prop: "invoicePrice",
                            label: "预计开票价(元)",
                            width: "140px"
                            
                        }
                    ]
				},
				{
                    prop: "",
                    label: "综合扣减",
                    children: [
                        {
                            prop: "taxRate",
                            label: "产品税率（%）",
                            width:"140px"
						},
						{
                            prop: "returnedMoneyDiscount",
                            label: "回款、流向折扣（%）",
                            width:"165px"
                            
                        },
                        {
							prop: "taxBalance",
							label: "简易计税补差（%）",
							width:"165px"
						}
                    ]
                },
				{
                    prop: "4",
					label: "最终计算后价格",
					isShowTip: true,
                    children: [
                        {
                            prop: "executingPriceAfterDiscount",
                            label: "执行中（元）",
                            width:"140px"
						},
						{
                            prop: "priceAfterDiscount",
                            label: "预计中标后（元）",
                            width:"155px"
                            
                        }
                    ]
                },
			],
			tableKey: 0,
			 
			editField:["adviseBidPrice ", "adviseStartExecDate","invoicePriceDownRatio"],
			editFieldType:["text","date","text"],
			editFieldHideBpc:[],
			formatterList:["adviseStartExecDate"],
			productTypes: [
				{
					value: '',
					label: '全部产品'
				}, {
					value: '1',
					label: '已上市'
				}, {
					value: '0',
					label: '未上市'
				}
			],
			changedType:"",
			taxList:[],
			paramTax:{
				"fillYear":new Date().getFullYear(),
				"dataVersion":this.$store.state.init.initData.dataVersion
			},
			pasteField:[
				{
					name:"adviseBidPrice ",
					type:"number",
					isCover:true,
					isCalculate:false
				},
				{
					name:"adviseStartExecDate",
					type:"date",
					isCover:true,
					isCalculate:false
				},
				{
					name:"invoicePriceDownRatio",
					type:"number",
					isCover:true,
					isCalculate:false
				}
			],//表格复制
		}
	},
	created(){
		this.getTaxList();
	},
	methods:{
		//下载模板
		// downLoad(){
		// 	window.location.href  = process.env.VUE_APP_serverUrl+'/bpc/income/'+this.type+'/downloadTemplet?fillPersonLevel='+this.$store.state.init.initData.fillPersonLevel;
		// },
		//导出
		checkOut(){
			window.location.href  = process.env.VUE_APP_serverUrl+'/bpc/income/'+this.type+'/price/export?configurationId='+this.$store.state.init.initData.configurationId;
		},
		// 复制
		pasteData(e){
			e.tableData.forEach((res,index)=>{
				// let val = eval("res."+pres.name);
				let e = {prop:'adviseBidPrice ',row:res};
				this.modification(e);
			})
		},
		//input 监听 index下标 row 一行数据 prop 属性 val值 新数组tableData
		modification(e){
		// 预计中标价 adviseBidPrice   预计下浮比例 invoicePriceDownRatio 预计开票价 invoicePrice
			if(e.row[e.prop]){
				if(e.prop == "adviseBidPrice " || e.prop == "invoicePriceDownRatio"){
					// 预计开票价=预计中标价/(1+预计下浮比例)
					e.row.invoicePrice = parseFloat(e.row.adviseBidPrice /(1+e.row.invoicePriceDownRatio/100)).toFixed(2);
					// 执行中中标价a-executingBidPrice  执行中开票价b-executingInvoicePrice 执行中下浮比例c-executingPriceDownRatio
					//  预计中标价A-adviseBidPrice  预计执行时间t-adviseStartExecDate 预计下浮比例C-invoicePriceDownRatio 预计开票价B-invoicePrice
					//  产品税率d-taxRate 回款、流向折扣e-returnedMoneyDiscount 简易计税补差f-taxBalance 
					// 执行中n-executingPriceAfterDiscount 预计中标后N-priceAfterDiscount
					 
					e.row.executingInvoicePrice=parseFloat(e.row.executingBidPrice/(1+e.row.executingPriceDownRatio/100)).toFixed(2);
					// e.row.executingPriceAfterDiscount = parseFloat(e.row.executingInvoicePrice*(1-e.row.returnedMoneyDiscount/100)*(1-e.row.taxBalance/100)/(1+e.row.taxRate/100)).toFixed(2);
					// n=b*（1-e-f）/（1+d) b=a/（1+c）
					e.row.executingPriceAfterDiscount = parseFloat(e.row.executingInvoicePrice*(1-e.row.returnedMoneyDiscount/100-e.row.taxBalance/100)/(1+e.row.taxRate/100)).toFixed(2);
					// N=B*（1-e-f）/（1+d) B=A/（1+C）
					e.row.priceAfterDiscount=parseFloat(e.row.invoicePrice*(1-e.row.returnedMoneyDiscount/100-e.row.taxBalance/100)/(1+e.row.taxRate/100)).toFixed(2);
					// e.row.invoicePrice=parseFloat(e.row.adviseBidPrice /(1+e.row.invoicePriceDownRatio/100)).toFixed(2)
				}else{
					// e.row.invoicePrice = "";
				}
                // if(e.prop == "adviseBidPrice" || e.prop == "invoicePriceDownRatio"){
                    // for(let tax of this.taxList){
                    //     if(tax.materialCode == e.row.materialCode){
					// 	   let taxField = "nextYearTaxRate";
					// 	    //预计开票价=预计中标价/（1+开票价下浮比例（老总最终版））；
					// 		e.row.invoicePrice = parseFloat(e.row.adviseBidPrice/(1+(e.row.invoicePriceDownRatio)/100)).toFixed(2);
					// 		// 无税开票价=预计开票价/(1+预计税率或预算税率)
					// 		e.row.taxlessInvoicePrice = parseFloat(e.row.invoicePrice/(1+tax[taxField])).toFixed(2);
					// 		//综合折扣后价格=无税开票价*（1-综合折扣比例）
					// 		e.row.priceAfterDiscount = parseFloat((e.row.taxlessInvoicePrice*(1-e.row.comprehensiveDiscountRatio/100)).toFixed(2));
					// 		break;
                    //     }
                    // }
                }
            // }else{
 				//预计开票价=预计中标价/（1+开票价下浮比例（老总最终版））；
				// e.row.invoicePrice = "";
				// 无税开票价=预计开票价/(1+预计税率或预算税率)
				// e.row.taxlessInvoicePrice = "";
				//综合折扣后价格=无税开票价*（1-综合折扣比例）
				// e.row.priceAfterDiscount = "";
			// }
			
		},
		loseFocus(){
			this.$emit("savePrice");
		},
		//需要编辑的加上类
		tableCellClassName({row, column, rowIndex, columnIndex}) {
			column.index = columnIndex
			let classname = "";
			if(this.editField.indexOf(column.property) != -1) {
				if (R.isNil(row[column.property]) || R.isEmpty(row[column.property]) || row[column.property].length == 0){
					classname += " placeholder-color";
				}else {
					classname += " normal-color";
				}
				classname += " edit";
				return classname;
			}
			if( column.property == "sfSales" && row.sfSales == "0" ){
				return "cellFocus";
			}
		},
		befclose() {
			this.showTable = false;
			this.$emit("befclose");
		},
		checkPrice(){
			this.$emit("changePriceType",this.changedType);
		},
	
		confirm(){
			this.$emit("savePrice",true);
		},
		getTaxList(){
			//税率
			salesApi.taxList(this.paramTax).then(res => {
				this.taxList = res.responseData;
			});
		},
		openedDialog(){
			setTimeout(()=>{
				this.showTable = true
			},1000);
		}
	}
}
</script>

<style lang="scss">
.priceDialog {
	// height: 80%;
	// overflow: hidden;
	.el-dialog{
		height: 80%;
		overflow: hidden;
	}
	.el-dialog__body{
		padding: 10px 20px;
		height: 90%;
	}
	.options{
		margin-bottom: 15px;
		.titleInfo{
			margin-bottom: 10px;
			.title{
				font-size: 18px;
				font-weight: bold;
				color:#323232;
				span{
					color: #ff7901
				}
			}
			.el-button--primary{
				background-color: #ffffff;
				color: #409eff;
			}
		}
		.cellLineProName{
			margin-right: 10px
		}
	}
	.tableBox{
		border-top: 1px solid #ebeef5;
		height: 100%;
		/deep/.el-table th{
			padding: 4px 0;
			line-height: 34px;
			div{
				line-height: 16px;
			}
		}
		.el-table tr td{
			padding: 0px
		}
		tr .edit .cell{
			padding: 0;
		}
		td:last-child{
			border-right: 1px solid #ebeef5!important;
		}
	}
	/deep/.el-table__body .cellFocus {
		color:#ff1111
	}
}
</style>

